import ReactLoadingSkeleton from 'react-loading-skeleton';

import styles from './Skeleton.module.css';

interface Props {
  className?: string;
  testid?: string;
}

export function Skeleton(props: Props) {
  const { className, testid } = props;
  return (
    <ReactLoadingSkeleton
      className={`${styles['loading-skeleton']} ${className}`}
      containerTestId={testid}
    />
  );
}
